<template>
	<div>
		<div class="row">
			<label class="col-form-label col-md-12" >Тип документа*  </label>
			<span class="col-md-12  like-lable">* Отключите отметку "Паспорт гражданина РФ" ниже, чтобы ввести данные загранпаспорта или паспорта другой страны</span>	
			<div class="col-md-12"><base-checkbox :checked="value.passport_rf" v-model="value.passport_rf">Паспорт гражданина РФ</base-checkbox></div>

			<label class="col-form-label col-md-12" >Паспорт серия</label>
			<div class="col-md-12" v-if="!value.passport_rf">
				<div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Паспорт серия" class="form-control" v-model.lazy="value.passer">
					</div>
				</div>
			</div>
			<base-input v-else class="col-md-12"
				v-model="value.passer"
				type="number"
				:name="errorLabel_passer"
				:error="getError(errorLabel_passer)"
				placeholder="Паспорт серия"
				v-validate="{passer:true}"
			></base-input>
			<label class="col-form-label col-md-12" >Паспорт номер</label>
			<div class="col-md-12" v-if="!value.passport_rf">
				<div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Паспорт номер" class="form-control" v-model.lazy="value.pasnum">
					</div>
				</div>
			</div>
			<base-input v-else class="col-md-12"
				v-model="value.pasnum"
				type="number"
				:name="errorLabel_pasnum"
				:error="getError(errorLabel_pasnum)"
				placeholder="Паспорт номер"
				v-validate="{pasnum:true}"
			></base-input>
			<label class="col-form-label col-md-12 formRequired" > <span> Дата выдачи </span></label>
			<div class="col-md-12">
				<div class="form-group">
					<div class="mb-0">
						<!-- <el-date-picker
							type="date"
							format="dd.MM.yyyy"
							value-format="yyyy-MM-dd"
							default-value="1990-01-01"	
							:picker-options="{firstDayOfWeek:1}"
							placeholder="ДД.ММ.ГГГГ"							
							v-model="value.passport_date"
							ref="dateUserInput"
						>
						</el-date-picker> -->
						<BaseDateTimePicker type="date" v-model="value.passport_date" />
					</div>
				</div>
			</div>
			<label class="col-form-label col-md-12" >Кем выдан</label>
			<div class="col-md-12">
				<base-input type="text" placeholder="Кем выдан" class="" v-model.lazy="value.passport_place"></base-input>
				<!-- <div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Кем выдан" class="form-control" v-model.lazy="value.passport_place">
					</div>
				</div> -->
			</div>
			<label class="col-form-label col-md-12" >Код подразделения</label>
			<div class="col-md-12">
				<base-input type="text" placeholder="Код подразделения" class="" v-model.lazy="value.passport_code"></base-input>
				<!-- <div class="form-group">
					<div class="mb-0">
						
					</div>
				</div> -->
			</div>
			<template v-if="value.passport_files!=''">
				<label class="col-form-label col-md-12">Загрузить фото паспорта</label>
				<div class="form-group col-md-12">
					<RePassportPhotos 
						v-model="value.passport_files"
					/>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import { BaseCheckbox } from 'src/components/index';
	import { DatePicker } from 'element-ui';
	import RePassportPhotos from 'src/our_components/RePassportPhotos.vue';
	import BaseDateTimePicker from 'src/our_components/datetimepickers/BaseDateTimePicker.vue';
	export default {
		name: 'RePassportFull',
		components: {
			BaseCheckbox,
			[DatePicker.name]: DatePicker,
			RePassportPhotos,
			BaseDateTimePicker,
		},
		props: {
			value: {
				type: Object,
				default: function(){return{
					passport_rf:true,
					passer: '',
					pasnum: '',
					passport_date: '',
					passport_place: '',
					passport_files: '',
					passport_code: '',
				}}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				errorLabel_passer: 'Серия паспорта',
				errorLabel_pasnum: 'Номер паспорта',
				elInputInData: '',
			}
		},
		watch:{
			
			// value(val){
			// 	console.log('val val ', val);
			// 	if(value.passport_date == ''){console.log('val val ');}
				
			// },

		},
		computed: {
			
		},
		methods: {
			getError(fieldName) {
				return this.errors.first(fieldName);
			},

		},
		mounted(){
				
		}
	}
</script>
<style scoped>
.like-lable {
	font-size: 0.75rem;
	line-height: 1.42857;
}
.white-content .card:not(.card-white) .like-lable:not(.btn) {
    color: #5C70A4;
}
</style>
